const ReportsChannel = () => {
  return <>reports channel</>
}

export default ReportsChannel
